"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandType = void 0;
var ExpandType;
(function (ExpandType) {
    ExpandType["metadata"] = "metadata";
    ExpandType["revisions"] = "revisions";
})(ExpandType = exports.ExpandType || (exports.ExpandType = {}));
